import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation('anfrage-sitaram');

  return (
    <footer className="bg-brand-green-700 px-4 py-10 text-white print:hidden sm:px-8">
      <div className="mx-auto grid max-w-7xl gap-8 md:grid-cols-3 md:items-center">
        <address className="text-sm not-italic leading-7">
          Ayurveda-Resort MANDIRA GmbH & Co KG
          <br />
          Wagerberg 120
          <br />
          8271 Bad Waltersdorf
          <br />
          {t('footer.country')}
        </address>

        <div className="flex justify-start md:justify-center">
          <img
            src="https://cdn.mandira-ayurveda.at/images/claim/2024/white_twoline.png"
            alt={t('footer.claim-alt')}
            width="250"
            height="200"
            className="h-auto w-52"
          />
        </div>

        <div className="flex flex-col gap-3 text-sm md:items-end md:text-right">
          <a className="underline" href="mailto:info@mandira-ayurveda.at">
            info@mandira-ayurveda.at
          </a>
          <a className="underline" href="tel:+4333332801">
            +43 3333 2801
          </a>
          <p>{t('footer.copyright')}</p>
          <a
            href="https://www.mauracher.com"
            className="text-xs no-underline text-brand-green-700 hover:text-brand-green-700 focus:text-brand-green-700"
          >
            Entwicklet von Mauracher IT-Solutions
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
